import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=19de7d73&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19de7d73')) {
      api.createRecord('19de7d73', component.options)
    } else {
      api.reload('19de7d73', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=19de7d73&", function () {
      api.rerender('19de7d73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tCSgwwHD1ZS6/JS/comp/IncreaseNumber.vue"
export default component.exports